module.exports = __webpack_public_path__ + "static/media/1023815.e5d144ff.jpg";